import styled from 'styled-components';

import { colors } from '../../../../utils/utils';

const Wrapper = styled.div<{ $rounded?: boolean; $isVisible?: boolean }>`
    position: absolute;
    z-index: 15;
    top: 38px;
    overflow: hidden;
    width: ${props => (props.$rounded ? '300px' : '100%')};
    height: ${props => (props.$isVisible ? 'calc(100% - 40px)' : '0px')};

    background-color: ${colors.white.basic};

    transition: height 0.25s ease;
    display: flex;
    flex-direction: column;
`;

export default Wrapper;
